import { createFileRoute } from '@tanstack/react-router';
import SystemSettingsPage from 'src/Administration/SystemSettingsPage/SystemSettingsPage';

export const Route = createFileRoute('/systemadmin/_layout/system-settings')({
  component: SystemSettingsPage,
});
